// View all supports lazy-loading, wherein a set of 4 reviews are loaded as user scrolls down the reviews
export const REVIEW_BATCH_SIZE = 4;

// In Venue Profile Page, there is an existing modal with z-index value of 20
// In order to hide it, we have used the value 20
export const Z_INDEX = 20;

// Carina Model supports three formats [s,m,l]
export enum ModalFormat {
    SMALL = 's',
    MEDIUM = 'm',
    LARGE = 'l',
}

// This is the breakpoints at which Carina Model format changes from 'm' to 's'
export const SCREEN_WIDTH_BREAKPOINT = 600;

// review sort order
export enum SortOrder {
    ASCENDING = 'ASC',
    DESCENDING = 'DESC',
}

// Review can have one of the 3 approval status
export enum ApprovalStatus {
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    PENDING = 'PENDING',
}
